"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useBreakpointObserver;

var _react = require("react");

var _reactHookSize = require("react-hook-size");

var _getActiveBreakpoint = _interopRequireDefault(require("./getActiveBreakpoint"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useBreakpointObserver(breakpoints) {
  var observedElementRef = (0, _react.useRef)();
  var dimensions = (0, _reactHookSize.useSize)(observedElementRef);
  var breakpoint = (0, _getActiveBreakpoint.default)(dimensions, breakpoints);
  return [observedElementRef, {
    breakpoint: breakpoint,
    dimensions: dimensions
  }];
}